interface PaymentBadgesProps {
  size?: "sm" | "md";
}

const PAYMENT_METHODS = [
  {
    id: "mada",
    label: "مدى",
    bg: "bg-[#1a1a1a]",
    border: "border-green-500/40",
    textColor: "text-green-400",
    icon: "ri-bank-card-line",
    iconColor: "text-green-400",
  },
  {
    id: "applepay",
    label: "Apple Pay",
    bg: "bg-[#1a1a1a]",
    border: "border-white/20",
    textColor: "text-white",
    icon: "ri-apple-line",
    iconColor: "text-white",
  },
  {
    id: "stcpay",
    label: "STC Pay",
    bg: "bg-[#1a1a1a]",
    border: "border-amber-400/40",
    textColor: "text-amber-400",
    icon: "ri-sim-card-line",
    iconColor: "text-amber-400",
  },
  {
    id: "tabby",
    label: "Tabby",
    bg: "bg-[#1a1a1a]",
    border: "border-lime-400/40",
    textColor: "text-lime-400",
    icon: "ri-time-line",
    iconColor: "text-lime-400",
  },
  {
    id: "tamara",
    label: "Tamara",
    bg: "bg-[#1a1a1a]",
    border: "border-orange-400/40",
    textColor: "text-orange-400",
    icon: "ri-calendar-line",
    iconColor: "text-orange-400",
  },
  {
    id: "visa",
    label: "Visa",
    bg: "bg-[#1a1a1a]",
    border: "border-gray-500/30",
    textColor: "text-gray-300",
    icon: "ri-secure-payment-line",
    iconColor: "text-gray-400",
  },
  {
    id: "mastercard",
    label: "Mastercard",
    bg: "bg-[#1a1a1a]",
    border: "border-red-400/30",
    textColor: "text-gray-300",
    icon: "ri-mastercard-line",
    iconColor: "text-red-400",
  },
];

export default function PaymentBadges({ size = "md" }: PaymentBadgesProps) {
  const isSmall = size === "sm";

  return (
    <div className="flex flex-wrap gap-2">
      {PAYMENT_METHODS.map((pm) => (
        <div
          key={pm.id}
          className={`flex items-center gap-1.5 ${pm.bg} border ${pm.border} rounded-lg transition-all ${
            isSmall ? "px-2 py-1" : "px-3 py-1.5"
          }`}
        >
          <div className={`flex items-center justify-center ${isSmall ? "w-3 h-3" : "w-4 h-4"}`}>
            <i className={`${pm.icon} ${pm.iconColor} ${isSmall ? "text-xs" : "text-sm"}`}></i>
          </div>
          <span
            className={`${pm.textColor} font-bold whitespace-nowrap ${isSmall ? "text-[10px]" : "text-xs"}`}
            style={{ fontFamily: "'Cairo', sans-serif" }}
          >
            {pm.label}
          </span>
        </div>
      ))}
    </div>
  );
}
